export const UI_TYPE_GROUP = "GROUP";
export const UI_TYPE_PRODUCT = "PRODUCT";
export const UI_TYPE_BRAND = "BRAND";
export const UI_TYPE_STATIC = "STATIC";
export const UI_TYPE_QL = "QUICK_LINK";
export const UI_TYPE_FOCUSED = "FOCUSED";
export const UI_TYPE_NORMAL = "NORMAL";

export const UI_QL_TYPE_UPLOAD_PRESCRIPTION = "UPLOAD_PRESCRIPTION";
export const UI_QL_TYPE_CALL_PHARMACIST = "CALL_PHARMACIST";
export const UI_QL_TYPE_CALL_CUSTOMER_CARE = "CALL_CUSTOMER_CARE";
export const UI_QL_TYPE_BLOOD_GLUCOSE = "BLOOD_GLUCOSE";
export const UI_QL_TYPE_BLOOD_REQUEST = "BLOOD_REQUEST";

export const UI_GROUP_TYPE_HORIZONTAL = "HORIZONTAL";
export const UI_GROUP_TYPE_VERTICAL = "VERTICAL";
export const UI_GROUP_TYPE_WEB_ONLY_HORIZONTAL = "WEB_HORIZONTAL";

export const UI_PRODUCT_TYPE_CATEGORY = "CATEGORY";
export const UI_PRODUCT_TYPE_HOT = "HOT";
export const UI_PRODUCT_TYPE_FEATURED = "FEATURED";
export const UI_PRODUCT_TYPE_FRESH = "FRESH";
export const UI_PRODUCT_TYPE_SALE = "SALE";

export const UI_BRAND_TYPE_ALL = "ALL_BRANDS";
export const UI_BRAND_TYPE_FEATURED = "FEATURED_BRANDS";
export const UI_BRAND_TYPE_WEEK = "BRAND_OF_WEEK";
export const UI_BRAND_TYPE_MONTH = "BRAND_OF_MONTH";
export const UI_BRAND_TYPE_DAY = "BRAND_OF_DAY";

export const UI_STATIC_TYPE_BANNER = "BANNER";
export const UI_STATIC_TYPE_NOTICE = "NOTICE";
export const UI_STATIC_TYPE_PREDICTION = "PREDICTION";
export const UI_STATIC_TYPE_REFERRAL = "REFERRAL";
export const UI_STATIC_TYPE_NAMASTE_DOC = "NAMASTE_DOCTOR";
export const UI_STATIC_TYPE_P_EVENTS = "PROMOTIONAL_EVENTS";
export const UI_STATIC_TYPE_CAMPAIGN = "CAMPAIGN";
export const UI_STATIC_TYPE_BLOOD_REQ = "BLOOD_REQUEST";
export const UI_STATIC_TYPE_MOBILE_FOOTER = "MOBILE_FOOTER";
export const UI_STATIC_REFER_OTHERS = "REFER_OTHERS";

export const UI_FOCUSED_TYPE_BRAND = "BRAND";
export const UI_FOCUSED_TYPE_CATEGORY = "CATEGORY";
export const UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN = "PRODUCT_CAMPAIGN";
export const UI_FOCUSED_TYPE_PRODUCT_DETAIL = "PRODUCT_DETAIL";
export const UI_FOCUSED_TYPE_PAGE = "PAGE";
export const UI_FOCUSED_TYPE_BLOG = "BLOG";
export const UI_FOCUSED_TYPE_OTHER = "OTHER";
export const TAB_ALL = "All";
export const TAB_DEFAULT = "Default";
export const TAB_PRODUCTS = "Product";
export const TAB_ADDED = "Added";
export const TAB_NOT_ADDED = "Not Added";
export const TAB_BRANDS = "Brand";
export const TAB_FOCUSED = "Focused";
export const TAB_ADDITIVES = "Additives";
export const TAB_PAGE = "Page";

export const DYNAMIC_PAGE_GROUP_CATEGORY = "category";
export const DYNAMIC_PAGE_GROUP_BRAND = "brand";
export const DYNAMIC_PAGE_GROUP_OTHERS = "others";
export const DYNAMIC_PAGE_GROUP_MONTH = "month";

export const ITEM_PER_PAGE_DYNAMIC_ITEMS = 20

export const DYNAMIC_TAB_LIST = {
  [TAB_ALL]: { title: TAB_ALL, id: 0 },
  [TAB_PRODUCTS]: { title: TAB_PRODUCTS, id: 1 },
  [TAB_DEFAULT]: { title: TAB_DEFAULT, id: 2 },
  // {title: TAB_ADDED},
  // {title: TAB_NOT_ADDED},
  [TAB_BRANDS]: { title: TAB_BRANDS, id: 3 },
  // {title: TAB_ADDITIVES},
  [TAB_FOCUSED]: { title: TAB_FOCUSED, id: 4 },
  [TAB_PAGE]: { title: TAB_PAGE, id: 5 }
};

export const ITEM_TABS = [
  { value: TAB_ALL },
  { value: TAB_PRODUCTS },
  { value: TAB_DEFAULT },
  // {title: TAB_ADDED},
  // {title: TAB_NOT_ADDED},
  { value: TAB_BRANDS },
  // {title: TAB_ADDITIVES},
  { value: TAB_FOCUSED },
  { value: TAB_PAGE }
];

// export const ITEM_TABS = [
//   {title: TAB_ALL},
//   {title: TAB_PRODUCTS},
//   {title: TAB_DEFAULT},
//   {title: TAB_ADDED},
//   {title: TAB_NOT_ADDED},
//   {title: TAB_BRANDS},
//   {title: TAB_ADDITIVES},
//   {title: TAB_FOCUSED},
//   {title: TAB_PAGE}
// ];

export const DYNAMIC_PAGE_GROUP_LIST = [
  { id: 2, value: DYNAMIC_PAGE_GROUP_CATEGORY, label: DYNAMIC_PAGE_GROUP_CATEGORY },
  { id: 3, value: DYNAMIC_PAGE_GROUP_BRAND, label: DYNAMIC_PAGE_GROUP_BRAND },
  { id: 4, value: DYNAMIC_PAGE_GROUP_OTHERS, label: DYNAMIC_PAGE_GROUP_OTHERS },
]

export const FOCUS_ITEM_SUB_TYPES = [
  {
    value: UI_FOCUSED_TYPE_BRAND,
    label: 'Brand'
  },
  {
    value: UI_FOCUSED_TYPE_CATEGORY,
    label: 'Category'
  },
  {
    value: UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN,
    label: 'Product Campaign'
  },
  {
    value: UI_FOCUSED_TYPE_PRODUCT_DETAIL,
    label: 'Product Detail'
  },
  {
    value: UI_FOCUSED_TYPE_PAGE,
    label: 'Dynamic Pages'
  },
  {
    value: UI_FOCUSED_TYPE_BLOG,
    label: 'Blogs'
  },
  {
    value: UI_FOCUSED_TYPE_OTHER,
    label: 'Others'
  }
];

export const PAGE_TAB_TYPES = [
  {
    value: UI_FOCUSED_TYPE_BRAND,
    label: 'Brand'
  },
  {
    value: UI_FOCUSED_TYPE_CATEGORY,
    label: 'Category'
  },
  {
    value: UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN,
    label: 'Product Campaign'
  },
  {
    value: UI_FOCUSED_TYPE_PAGE,
    label: 'Dynamic Pages'
  }
];

export const DYNAMIC_UI_TYPE_LIST = [
  {
    value: UI_TYPE_PRODUCT,
    label: 'Product',
    sub_types: [
      // {
      //   value: UI_PRODUCT_TYPE_CATEGORY,
      //   label: 'Category'
      // },
      {
        value: UI_PRODUCT_TYPE_HOT,
        is_default: true,
        label: 'Hot Sale'
      },
      {
        value: UI_PRODUCT_TYPE_FRESH,
        is_default: true,
        label: 'Fresh Sale'
      },
      {
        value: UI_PRODUCT_TYPE_SALE,
        is_default: true,
        label: 'Flash Sale'
      },
      {
        value: UI_PRODUCT_TYPE_FEATURED,
        is_default: true,
        label: 'Featured'
      }
    ]
  },
  {
    value: UI_TYPE_BRAND,
    sub_types: [
      {
        value: UI_BRAND_TYPE_ALL,
        is_default: true,
        label: 'All Brands'
      },
      {
        value: UI_BRAND_TYPE_FEATURED,
        is_default: true,
        label: 'Featured Brands'
      },
      {
        value: UI_BRAND_TYPE_WEEK,
        is_default: true,
        label: 'Brand of Week'
      },
      {
        value: UI_BRAND_TYPE_MONTH,
        label: 'Brand of Month'
      },
      {
        value: UI_BRAND_TYPE_DAY,
        label: 'Brand Day'
      }
    ],
    label: 'Brand'
  },
  {
    value: UI_TYPE_STATIC,
    sub_types: [
      {
        value: UI_STATIC_TYPE_BANNER,
        label: 'Banner'
      },
      {
        value: UI_STATIC_TYPE_NOTICE,
        label: 'Notice'
      },
      {
        value: UI_STATIC_TYPE_REFERRAL,
        label: 'Referral'
      },
      {
        value: UI_STATIC_TYPE_NAMASTE_DOC,
        label: 'Namaste Doctor'
      },
      {
        value: UI_STATIC_TYPE_P_EVENTS,
        label: 'Promotional Events'
      },
      {
        value: UI_STATIC_TYPE_CAMPAIGN,
        label: 'Campaign'
      },
      {
        value: UI_STATIC_TYPE_BLOOD_REQ,
        label: 'Blood Request'
      },
      {
        value: UI_STATIC_TYPE_MOBILE_FOOTER,
        label: 'Mobile Footer'
      }
    ],
    is_default: true,
    label: 'Normal'
  },
  {
    value: UI_TYPE_FOCUSED,
    sub_types: FOCUS_ITEM_SUB_TYPES,
    label: 'Focused'
  },
  {
    value: UI_TYPE_QL,
    sub_types: [
      {
        value: UI_QL_TYPE_BLOOD_GLUCOSE,
        label: 'Blood Glucose',
        is_default: true
      },
      {
        value: UI_QL_TYPE_BLOOD_REQUEST,
        label: 'Blood Request',
        is_default: true
      },
      {
        value: UI_QL_TYPE_UPLOAD_PRESCRIPTION,
        label: 'Upload Prescription',
        is_default: true
      },
      {
        value: UI_QL_TYPE_CALL_CUSTOMER_CARE,
        label: 'Blood Glucose',
        is_default: true
      },
      {
        value: UI_QL_TYPE_CALL_PHARMACIST,
        label: 'Blood Glucose',
        is_default: true
      }
    ],
    label: 'Focused'
  },
  {
    value: UI_TYPE_GROUP,
    label: 'Group',
    name: 'Display type',
    sub_types: [
      {
        value: UI_GROUP_TYPE_HORIZONTAL,
        label: 'Horizontal'
      },
      {
        value: UI_GROUP_TYPE_VERTICAL,
        label: 'Vertical'
      },
      {
        value: UI_GROUP_TYPE_WEB_ONLY_HORIZONTAL,
        label: 'Web Horizontal'
      }
    ]
  },
  {
    value: UI_TYPE_NORMAL,
    label: "Normal",
    name: 'Normal Type',
    sub_types: [
      {
        value: UI_STATIC_TYPE_BANNER,
        label: 'Banner'
      },
      {
        value: UI_STATIC_TYPE_PREDICTION,
        label: 'Prediction'
      },
    ]
  }

];

//Aspect Ratios
//Full Banner (Slider banner, Sub banner mobile, Focus list banner)
export const ASPECT_RATIO_FULL_BANNER_IMAGE_MOBILE = 720 / 362;
export const ASPECT_RATIO_FULL_BANNER_IMAGE_WEB = 1500 / 402;
//Cart Banner
export const ASPECT_RATIO_CART_BANNER_IMAGE_MOBILE = 800 / 218;
export const ASPECT_RATIO_CART_BANNER_IMAGE_WEB = 1500 / 212;
//Sub Banner (category banner / brand banner)
export const ASPECT_RATIO_SUB_BANNER_IMAGE_WEB = 1440 / 362;
//Full Banner with discount (Focus full banner with discount)
export const ASPECT_RATIO_FULL_BANNER_WITH_DISCOUNT_MOBILE = 342 / 220;
export const ASPECT_RATIO_FULL_BANNER_WITH_DISCOUNT_WEB = 342 / 210;
//Vertical Banner (Featured banner, Focus grid banner)
export const ASPECT_RATIO_VERTICAL_BANNER_IMAGE = 1200 / 1800;
export const ASPECT_RATIO_VERTICAL_BANNER_WITH_DISCOUNT = 166 / 286;
export const ASPECT_RATIO_VERTICAL_FOCUS_BANNER_WITH_DISCOUNT = 166 / 298;
export const ASPECT_RATIO_VERTICAL_FOCUS_BANNER_WITH_DISCOUNT_WEB = 161 / 280;
export const ASPECT_RATIO_SQUARE_BANNER_WITH_DISCOUNT = 166 / 214;
//Campaign Banner
export const ASPECT_RATIO_CAMPAIGN_BANNER_MOBILE = 1;
export const ASPECT_RATIO_CAMPAIGN_BANNER_WEB = 1500 / 512.57;


export const SELECTED = "SELECTED";
export const  UNSELECTED = "UNSELECTED";

export const DYNAMIC_SECTION_TABS= [
  { value: SELECTED, label: 'Selected'},
  { value: UNSELECTED, label: 'Unselected'},
]


export const SEARCH_MODE = "SEARCH";
export const LIST_MODE = "LIST";
